export const helper_ani = {
	init: { opacity: 0, y: -3, marginTop: 0 },
	ani: {
		opacity: 1,
		y: 0,
		marginTop: 4,
		transition: { duration: 0.2 },
	},
	exit: {
		opacity: 0,
		y: -3,
		marginTop: 0,
		transition: { duration: 0.2 },
	},
};
